import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_101: FaireProductEntity = {
  token: "legacy_prod_abbott-101",
  type: "product",
  name: 'Large Sheep on Legs Planter 3" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c678d59dc177b41273690eed26b95c2c070d5cd6c6bb866378acb7cfb3c2d000.jpeg",
  priceDollars: 22,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
